export default {
  text: "If you're confused, give us a call at 646-786-0888. Or if you would like to come for an in-person interview, please follow the instructions here to set up a meeting."
};
